module.exports = __webpack_public_path__ + "img/9.5a3c1005.jpg";